import ImageViewer from './ImageViewer';

export { ImageViewer };

export default {
	ImageViewer
};
